export default __webpack_public_path__ + "static/media/3.39ffe79b.png";